// removed by extract-text-webpack-plugin
module.exports = {"phone":"_3vJy3-phone","phone_icon":"_3I1Iu-phone_icon"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/PhoneInput/PhoneInput.scss
// module id = 805
// module chunks = 0